import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Select from 'react-select';

const LabeledDropDown = ({ name, label, options = [], registerOptions = {}, ...rest }) => {
  const { control, formState: { errors }, setValue, getValues } = useFormContext();

  useEffect(() => {
    const currentValue = getValues(name);
    setValue(name, currentValue);
  }, [name, setValue, getValues]);

  const inputStyle = {
    padding: '2px',
    marginBottom: '10px',
    width: '100%',
    borderColor: errors[name] ? 'red' : 'lightgray',
    borderRadius: '5px',
    outline: 'none',
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px',
    color: 'black',
  };

  const isRequired = registerOptions?.required;

  return (
    <div className="form-group" style={{ marginBottom: '15px' }}>
      <label style={labelStyle}>
        {label}{isRequired && <span className="required-asterisk">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={registerOptions}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            placeholder="Select"
            onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.value : '')}
            value={options.find(option => option.value === field.value) || null}
            isDisabled={rest.disabled}
            isSearchable={false}
            styles={{
              control: (provided) => ({
                ...provided,
                ...inputStyle,
                boxShadow: 'none',
                border: `1px solid ${inputStyle.borderColor}`,
                '&:hover': {
                  border: `1px solid ${inputStyle.borderColor}`,
                },
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
                margin: "0px",
                padding: "0px",
              }),
              option: (provided) => ({
                ...provided,
                color: 'black',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'lightgray',
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                color: 'black',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'gray',
              }),
              clearIndicator: (provided) => ({
                ...provided,
                display: 'none',
              }),
              indicatorSeparator: (provided) => ({
                ...provided,
                display: 'none',
              }),
            }}
            {...rest}
          />
        )}
      />
      {errors[name] && <span className="text-danger">{errors[name].message}</span>}
    </div>
  );
};

export default LabeledDropDown;
